<template>
  <div>
    <div class="max-w-7xl mx-auto my-5" v-if="!hasAccessToMarketing">
      <div class="px-1 md:px-20">
        <div class="mt-8  pb-16 sm:mt-12 sm:pb-20 lg:pb-28">
          <div class="relative">
            <div class="absolute inset-0 h-1/2 bg-gray-100"></div>
            <div class="relative max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
              <div
                class="max-w-lg mx-auto rounded-lg shadow-lg overflow-hidden lg:max-w-none lg:flex"
              >
                <div class="bg-white px-6 py-8 lg:p-12">
                  <h3
                    class="text-2xl leading-8 font-extrabold text-gray-900 sm:text-3xl sm:leading-9"
                  >
                    Whatsapp Marketing
                  </h3>
                  <p class="mt-6 text-base leading-6 text-gray-500">
                    Woohoo! Whatsapp has officially allowing merchants to send
                    marketing campaigns with the whatsapp business number.
                  </p>
                  <div class="mt-8">
                    <div class="flex items-center">
                      <h4
                        class="flex-shrink-0 pr-4 bg-white text-sm leading-5 tracking-wider font-semibold uppercase"
                      >
                        What's included
                      </h4>
                      <div class="flex-1 border-t-2 border-gray-200"></div>
                    </div>
                    <ul
                      class="mt-8 lg:grid lg:grid-cols-2 lg:gap-x-8 lg:gap-y-5"
                    >
                      <li class="flex items-start lg:col-span-1">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Highest open rate than Email or sms
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Free Whatsapp API approval
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Custom template approval
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Priority customer support
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Send targeted messages and increase sales
                        </p>
                      </li>
                      <li class="mt-5 flex items-start lg:col-span-1 lg:mt-0">
                        <div class="flex-shrink-0">
                          <!-- Heroicon name: check-circle -->
                          <svg
                            class="h-5 w-5 text-green-400"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        </div>
                        <p class="ml-3 text-sm leading-5 text-gray-700">
                          Segment your customers and send campaigns
                        </p>
                      </li>
                    </ul>
                  </div>
                </div>
                <div
                  class="py-8 px-6 text-center bg-gray-50 lg:flex-shrink-0 lg:flex lg:flex-col lg:justify-center lg:p-12"
                >
                  <div class="mt-6">
                    <div class="rounded-md shadow">
                      <a
                        class="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out cursor-pointer"
                        @click="sendOwnNumber()"
                        v-if="!showRequestAccessButton"
                      >
                        Get Whatsapp API Approval
                      </a>
                      <a
                        class="flex items-center justify-center px-5 py-3 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-gray-900 hover:bg-gray-800 focus:outline-none focus:shadow-outline transition duration-150 ease-in-out cursor-pointer"
                        v-if="showRequestAccessButton"
                        @click="sendOwnNumber"
                      >
                        Get Whatsapp API Approval
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class=" sm:block" v-else>
      <div class="flex ">
        <!-- <Sidebar /> -->
        <Page
          class="w-full"
          style="padding-left: 0; padding-right: 0; padding-top: 0;"
        >
          <div>
            <div class="flex justify-between">
              <div class="Polaris-Tabs__Outer">
                <div
                  class="Polaris-Box"
                  style="--pc-box-padding-block-start-md:var(--p-space-200);--pc-box-padding-block-end-md:var(--p-space-200);--pc-box-padding-inline-start-md:var(--p-space-200);--pc-box-padding-inline-end-md:var(--p-space-200)"
                >
                  <div class="Polaris-Tabs Polaris-Tabs__TabsMeasurer">
                    <li
                      v-for="(tab, index) of tabs"
                      :key="index"
                      class="Polaris-Tabs__TabContainer"
                      role="presentation"
                    >
                      <button
                        :id="tab.routeName + 'Measurer'"
                        class="Polaris-Tabs__Tab"
                        :class="{
                          'Polaris-Tabs__Tab--active':
                            $route.name === tab.routeName
                        }"
                        role="tab"
                        type="button"
                        tabindex="-1"
                        :aria-selected="$route.name === tab.routeName"
                      >
                        <div
                          class="Polaris-InlineStack"
                          style="--pc-inline-stack-align:center;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:nowrap;--pc-inline-stack-gap-xs:var(--p-space-200);--pc-inline-stack-flex-direction-xs:row"
                        >
                          <span
                            class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                            >{{ tab.label }}</span
                          >
                        </div>
                      </button>
                    </li>
                  </div>
                  <div class="Polaris-Tabs__Wrapper">
                    <div class="Polaris-Tabs__ButtonWrapper">
                      <ul
                        class="Polaris-Tabs"
                        data-tabs-focus-catchment="true"
                        role="tablist"
                      >
                        <li
                          v-for="(tab, index) of tabs"
                          :key="index"
                          class="Polaris-Tabs__TabContainer"
                          role="presentation"
                        >
                          <router-link
                            :id="tab.routeName"
                            class="Polaris-Tabs__Tab"
                            :class="{
                              'Polaris-Tabs__Tab--active':
                                $route.name === tab.routeName
                            }"
                            :aria-label="tab.label"
                            role="tab"
                            :to="{ name: tab.routeName }"
                            :aria-controls="tab.routeName + '-content'"
                            :tabindex="$route.name === tab.routeName ? 0 : -1"
                            :aria-selected="$route.name === tab.routeName"
                          >
                            <div
                              class="Polaris-InlineStack"
                              style="--pc-inline-stack-align: center; --pc-inline-stack-block-align: center; --pc-inline-stack-wrap: nowrap; --pc-inline-stack-gap-xs: var(--p-space-200); --pc-inline-stack-flex-direction-xs: row;"
                            >
                              <span
                                class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                                >{{ tab.label }}</span
                              >
                            </div>
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <button
                class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantPrimary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter"
                type="button"
                @click="gotoNewCampaign"
              >
                <span
                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--medium"
                >
                  <template v-if="isLoading">
                    <svg
                      class="animate-spin h-4 w-4 mr-2 inline"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        class="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        stroke-width="4"
                      ></circle>
                      <path
                        class="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      ></path>
                    </svg>
                    Loading...
                  </template>
                  <template v-else>
                    Send new campaign
                  </template>
                </span>
              </button>
            </div>

            <div
              class="Polaris-Tabs__Panel w-full"
              :id="$route.name + '-content'"
              role="tabpanel"
              :aria-labelledby="$route.name"
              tabindex="-1"
            >
              <div class="Polaris-LegacyCard__Section">
                <div class="flex flex-col max-w-7xl mx-auto">
                  <router-view></router-view>
                </div>
              </div>
            </div>
          </div>
        </Page>
        <!-- <div class="max-w-5xl mx-auto ">
          <router-view />
        </div> -->
      </div>
    </div>
    <OwnNumberForm
      v-if="showOwnNumberForm"
      @close="showOwnNumberForm = false"
    />
    <AdvancedPlanAlert
      feautureType="marketing"
      v-if="showAdvancedPlanAlert"
      @close="showAdvancedPlanAlert = false"
    />
    <UsageChargeUpgradeModal
      v-if="showUsageChargeIncreaseModal"
      @close="showUsageChargeIncreaseModal = false"
      :usageCapUrl="usageCapUrl"
    ></UsageChargeUpgradeModal>
  </div>
</template>

<script>
import Page from "../components/Common/Page.vue";

import AdvancedPlanAlert from "../components/Forms/AdvancedPlanAlert.vue";
import OwnNumberForm from "../components/Forms/OwnNumberForm.vue";
import UsageChargeUpgradeModal from "../components/Marketing/UsageChargeUpgradeModal.vue";

// import Sidebar from "../components/Marketing/Sidebar.vue";

export default {
  components: {
    // Sidebar,
    Page,
    OwnNumberForm,
    AdvancedPlanAlert,
    UsageChargeUpgradeModal
  },
  data() {
    return {
      hasAccessToMarketing: false,
      showOwnNumberForm: false,
      showAdvancedPlanAlert: false,
      showRequestAccessButton: false,
      automationConfig: {},
      pageTitle: "Marketing",
      tabs: [
        {
          label: "Campaigns",
          routeName: "Campaigns"
        },
        {
          label: "Message Logs",
          routeName: "MarketingMessageLogs"
        }
      ],
      showUsageChargeIncreaseModal: false,
      usageCapUrl: "",
      isLoading: false
    };
  },
  created() {
    const store = this.$store.getters.getStore;
    if (store.hasAccessToMarketing) {
      this.hasAccessToMarketing = true;
      return;
    }
    if (store.plan === "advanced") {
      this.$store.dispatch("getAutomationConfig").then(response => {
        this.automationConfig = response.config;
        if (
          this.automationConfig.customAppName &&
          this.automationConfig.customAppName.indexOf("rx") === -1
        ) {
          this.showRequestAccessButton = true;
        }
      });
    }
  },
  methods: {
    sendOwnNumber() {
      const { plan } = this.$store.getters.getStore;
      if (plan != "advanced") {
        this.showAdvancedPlanAlert = true;
      } else {
        this.showOwnNumberForm = true;
      }
    },
    requestAccessToMarketing() {
      // eslint-disable-next-line
      $crisp.push([
        "do",
        "message:send",
        ["text", `Need access to whatsapp marketing`]
      ]);
    },
    gotoNewCampaign() {
      // Check eligibility before navigating to CreateCampaign
      this.isLoading = true;
      this.$store
        .dispatch("getMarketingEligiblity")
        .then(response => {
          this.isLoading = false;
          if (response.needsUpdate) {
            this.usageCapUrl = response.url;
            this.showUsageChargeIncreaseModal = true;
          } else {
            this.$router.push({
              name: "CreateCampaign"
            });
          }
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
          alert("please contact support to send campaign");
        });
      return;
    }
  }
};
</script>

<style lang="scss" scoped></style>
